export const REQUEST_LIST_LOCKDOWN_PLANS =
  'app/global/lockdownPlans/REQUEST_LIST_LOCKDOWN_PLANS';
export const SET_LOCKDOWN_PLANS = 'app/global/lockdownPlans/SET_LOCKDOWN_PLANS';
export const TRIGGER_LOCKDOWN_PLAN =
  'app/global/lockdownPlans/TRIGGER_LOCKDOWN_PLAN';
export const REVERT_LOCKDOWN_PLAN =
  'app/global/lockdownPlans/REVERT_LOCKDOWN_PLAN';
